"use client";

import { useRouter } from "next/navigation";

type BackRouterProps = {
  children: React.ReactNode;
};

export default function BackRouter({ children }: BackRouterProps) {
  const router = useRouter();

  return <span onClick={router.back}>{children}</span>;
}
